import React from 'react'
import styled from '@emotion/styled'
import { mediaQueriesByDevice } from 'parameters/index'
import { CardBackgroundTheme } from 'components/patterns/themes/styles/backgrounds'
import { TextColorTheme } from 'components/patterns/themes/styles/text'
import { UrlObject } from 'url'
import { SEOLink } from 'components/elements/links/SEOLink'

interface TileProps {
	text: string
	destination: UrlObject
}

export const SquareTile: React.FC<React.PropsWithChildren<TileProps>> = ({ text, destination, children }) => (
	<SEOLink href={destination}>
		<ItemWrapper>
			<ImageWrapper>{children}</ImageWrapper>
			<ItemText>{text}</ItemText>
		</ItemWrapper>
	</SEOLink>
)

const ItemWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	flex: 0 0 auto;
	width: 190px;
	height: 120px;
	box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.08);
	border-radius: 16px;
	${CardBackgroundTheme};
	padding: 24px 16px;
	cursor: pointer;
	transition: transform 0.3s;
	position: relative;

	&:hover {
		transform: translateY(5px);
	}

	${mediaQueriesByDevice.tablet} {
		flex-direction: row;
		width: 100%;
		padding: 16px;
		height: unset;
		justify-content: flex-start;
		height: 64px;
		border-radius: 4px;
	}
`

const ImageWrapper = styled.div`
	margin-bottom: 10px;

	${mediaQueriesByDevice.tablet} {
		min-width: 50px;
		display: flex;
		align-items: center;
		justify-content: flex-start;

		svg {
			width: 32px;
		}
	}
`

const ItemText = styled.span`
	font-size: 18px;
	font-weight: bold;
	line-height: 1.33;
	text-align: center;
	max-width: 125px;
	${TextColorTheme};

	${mediaQueriesByDevice.tablet} {
		max-width: unset;
	}
`
